<template>
  <el-dialog
    class="rc-dialog"
    :title="curdTitle"
    :visible.sync="CUFlag"
    v-if="CUFlag"
    @close="loseDialog"
    :close-on-click-modal="false"
  >
    <el-form
      class="form"
      size="small"
      label-position="right"
      label-width="100px"
      :rules="rules"
      :model="videoForm"
      ref="videoForm"
    >
      <el-row :gutter="12">
        <el-col>
          <el-form-item label="视频名称：" prop="videoName" required>
            <el-input
              v-model="videoForm.videoName"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item
            id="video"
            class="scale"
            label="视频内容："
            prop="videoLink"
            required
          >
            <av-preview
              v-if="videoForm.videoLink"
              :src="videoForm.videoLink"
              @duration="videoDuration"
              @delete="deleteVideo"
            >
            </av-preview>
            <upload
              v-else
              type="video"
              :path="'shortVideo/video'"
              v-model="videoForm.videos"
            />
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item
            id="image"
            class="scale"
            label="视频封面："
            prop="coverUrl"
          >
            <av-preview
              v-if="videoForm.coverUrl"
              :src="videoForm.coverUrl"
              type="image"
              @delete="deleteCover"
            />
            <upload
              v-else
              :draggable="false"
              :path="'shortVideo/img'"
              type="image"
              v-model="videoForm.covers"
            />
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item label="视频分类：" prop="categoryId" required>
            <el-select
              v-model="videoForm.categoryId"
              placeholder="请选择视频分类"
              class="form-select"
            >
              <el-option
                v-for="item in categoryData"
                :key="item.uuid"
                :label="item.categoryName"
                :value="item.uuid"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item label="发布主体：" prop="publisherId" required>
            <el-select
              v-model="videoForm.publisherId"
              placeholder="请选择发布主体"
              class="form-select"
            >
              <el-option
                v-for="item in publisherData"
                :key="item.uuid"
                :label="item.publisherName"
                :value="item.uuid"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item
            class="scale"
            label="是否发布："
            prop="isDirectOnline"
            required
          >
            <el-radio-group v-model="videoForm.isDirectOnline">
              <el-radio
                v-for="item in onlineData"
                :key="item.paramKey"
                :label="item.paramKey"
                >{{ item.paramValue }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <butn @click.native="closeFrom('videoForm')" btntype title="取消"></butn>
      <butn btntype="primary" @click.native="createData()" title="确定"></butn>
    </div>
  </el-dialog>
</template>

<script>
import videoForm from "@/mixins/shortVideo-form";
import butn from "@/components/button/index";
import Bus from "./bus";
import {
  shortVideoSave,
  shortVideoEdit,
  shortVideoInfo
} from "@/api/shortVideo";
import { categoryList } from "@/api/shortCategory";
import { publisherList } from "@/api/shortVideoPublisher";
import { getDataMap } from "@/api/sysParam";
import Upload from "@/components/upload/index";
import AvPreview from "@/components/av-preview/index";

export default {
  mixins: [videoForm],
  components: { butn, Upload, AvPreview },
  data() {
    return {
      Bus,
      curdTitle: "",
      CUFlag: false,
      onlineData: [],
      categoryData: [],
      publisherData: [],
      scale: 0.8,
      image: {},
      video: {},
      command: function() {}
    };
  },
  created() {
    // 获取视频状态
    getDataMap("ONLINE_STATUS").then(res => {
      if (!res || res.code != 0) return;
      this.onlineData = res.data;
    });
    // 获取视频分类
    categoryList().then(res => {
      if (!res || res.code != 0) return;
      this.categoryData = res.data;
    });
    // 获取视频发布主体
    publisherList().then(res => {
      if (!res || res.code != 0) return;
      this.publisherData = res.data;
    });
    var _this = this;
    Bus.$on("ReceiveMessage", function(item) {
      _this.$nextTick(() => {
        _this.curdTitle = item.uuid == "" ? "新增微视频" : "编辑微视频";
        _this.command = item.uuid == "" ? shortVideoSave : shortVideoEdit;
        _this.CUFlag = true;
        if (item.uuid) {
          shortVideoInfo(item.uuid).then(res => {
            if (!res || res.code != 0) return;
            const { data } = res;
            _this.videoForm = {
              uuid: data.uuid,
              videoName: data.videoName,
              videoLink: data.videoLink,
              videos: [{ url: data.videoLink, size: data.videoSize }],
              coverUrl: data.coverUrl,
              covers: [{ url: data.coverUrl }],
              categoryId: data.categoryId,
              publisherId: data.publisherId,
              onlineStatus: data.onlineStatus,
              isDirectOnline:
                data.onlineStatus != null && data.onlineStatus.toString()
            };
          });
        }
      });
    });
  },

  methods: {
    //设置封面
    //新增|编辑视频
    createData() {
      this.$refs.videoForm.validate(valid => {
        if (valid) {
          this.loading = true;
          //封面为空取视频内容第一帧作为封面
          if (
            this.videoForm.coverUrl == "" ||
            this.videoForm.coverUrl == null
          ) {
            this.videoForm.coverUrl =
              this.videoForm.videoLink +
              "?x-oss-process=video/snapshot,t_0,f_jpg,w_0,h_0,m_fast,ar_auto";
          }
          let params = { ...this.videoForm };
          delete params.videos;
          delete params.covers;
          //const params = Object.assign({}, this.videoForm);
          if (this.videoForm.isDirectOnline == 1) {
            params["onlineStatus"] = 1;
          } else {
            params["onlineStatus"] = 0;
          }
          this.command(params).then(res => {
            this.loading = false;
            if (res && res.code == 0) {
              this.$message.success(res.msg);
              Bus.$emit("reload");
              this.CUFlag = false;
            }
          });
        }
      });
    },
    // 删除视频  时长重置为0
    deleteVideo() {
      this.videoForm.videos = [];
      this.videoForm.videoLength = 0;
    },
    // 删除封面
    deleteCover() {
      this.videoForm.covers = [];
    },
    videoDuration(t) {
      this.videoForm.videoLength = t;
    },
    closeFrom(videoForm) {
      this.CUFlag = false;
      // 点击取消 数据重置
      this.$refs[videoForm].resetFields();
      this.videoForm.videos = [];
      this.videoForm.videoLength = 0;
      this.videoForm.covers = [];
    },
    loseDialog() {
      this.CUFlag = false;
      // 点击取消 数据重置
      this.$refs["videoForm"].resetFields();
      this.videoForm.videos = [];
      this.videoForm.videoLength = 0;
      this.videoForm.covers = [];
    }
  }
};
</script>

<style lang="scss" scoped></style>
